import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ValueScore from './ValueScore';

const fmt = (value, suffix = '') =>
  value != null ? `${value}${suffix}` : 'N/A';

const fmtMoney = (value) => {
  if (value == null) return 'N/A';
  if (Math.abs(value) >= 1e12) return `$${(value / 1e12).toFixed(2)}T`;
  if (Math.abs(value) >= 1e9)  return `$${(value / 1e9).toFixed(2)}B`;
  if (Math.abs(value) >= 1e6)  return `$${(value / 1e6).toFixed(2)}M`;
  return `$${value.toFixed(2)}`;
};

const MetricCard = ({ label, value, positive }) => (
  <div className="ai-metric-card">
    <div className="ai-metric-label">{label}</div>
    <div className={`ai-metric-value ${positive === true ? 'positive' : positive === false ? 'negative' : ''}`}>
      {value}
    </div>
  </div>
);

const AIAnalysis = ({ data }) => {
  if (!data || !data.analysis) return <div>No AI analysis available</div>;

  const { analysis, rawMetrics, currentPrice, marketCap, symbol } = data;
  const m = rawMetrics?.threeYearMetrics;

  return (
    <div className="ai-analysis">

      {/* Metrics strip */}
      <div className="ai-metrics-strip">
        <MetricCard label="Current Price" value={`$${Number(currentPrice).toFixed(2)}`} />
        <MetricCard label="Market Cap" value={fmtMoney(marketCap)} />
        {m?.revenueGrowth  != null && (
          <MetricCard
            label="3Y Revenue Growth"
            value={fmt(m.revenueGrowth.toFixed(2), '%')}
            positive={m.revenueGrowth >= 0}
          />
        )}
        {m?.earningsGrowth != null && (
          <MetricCard
            label="3Y Earnings Growth"
            value={fmt(m.earningsGrowth.toFixed(2), '%')}
            positive={m.earningsGrowth >= 0}
          />
        )}
        {analysis.model && analysis.model !== 'fallback' && (
          <div className="ai-model-badge">
            {analysis.model}
            {analysis.cachedAt && (
              <div className="ai-analysis-date">
                {new Date(analysis.cachedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Value Score widget */}
      {symbol && <ValueScore symbol={symbol} />}

      {/* Markdown body */}
      <div className="ai-markdown-body">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {analysis.content}
        </ReactMarkdown>
      </div>

    </div>
  );
};

export default AIAnalysis;
